// 根据目前开发环境还是shopify环境，获取对应的shopify token 并返回
export async function getShopifyIdToken(): Promise<string> {
  const token = await shopify.idToken()
  return token ?? ''
}